import Section from "../../section/Section"
import { ICardFieldProps } from "../cards/CardField"

/* Protopia Ecosystem component */
const CardFieldSection = (props: ICardFieldProps): JSX.Element => {
    const { value, field, section, i } = props
    return <div 
        className={`landing-card-field landing-card-field-section ${value.className || ""}`} 
        style={{ ...field.style, ...value.style }}  
        data-card-field-id={i}
        card-field-section-id={section.id}
    >
        <Section
            i={0} 
            section={value.data?.section}
        />
    </div>
}
export default CardFieldSection